import React from "react";
import { DPButton } from "Components/DP";
import useStyles from "./styles";
import { useMutation } from "@apollo/client";
import mutations from "Shared/mutations";
import {
  GeneratePayrollAnomalyReportMutation,
  GeneratePayrollAnomalyReportMutationVariables,
} from "generated/graphql";
import { downloadS3File } from "Modules/S3Downloads";
import { errorToast } from "Modules/DPToast";

export interface ExportReportButtonProps {
  netEarningsFileId: string;
}

export const DownloadReportButton = ({ netEarningsFileId }: ExportReportButtonProps) => {
  const classes = useStyles();

  const [generatePayrollAnomalyReport] = useMutation<
    GeneratePayrollAnomalyReportMutation,
    GeneratePayrollAnomalyReportMutationVariables
  >(mutations.GENERATE_PAYROLL_ANOMALY_REPORT);

  const onButtonClickHandler = async () => {
    try {
      const { data } = await generatePayrollAnomalyReport({
        variables: {
          payrollJournalId: netEarningsFileId,
        },
      });
      downloadS3File(data!.generatePayrollAnomalyReportUrl.reportUrl);
    } catch (err) {
      errorToast("Something went wrong. Please, try again later.");
    }
  };

  return (
    <DPButton
      onClick={onButtonClickHandler}
      size="large"
      className={classes.downloadButton}
    >
      Download
    </DPButton>
  );
};
